module.exports = __webpack_public_path__ + "static/media/tax_filing_banner.4079918f.svg";